import { useCookieRedirect } from '~/composables/useCookieRedirect';
import { useMerchantSlug } from '~/composables/useMerchantSlug';
import { useSupabaseUser } from '~/composables/useSupabaseUser';

export default defineNuxtRouteMiddleware((to) => {
	const user = useSupabaseUser();
	const merchantSlug = useMerchantSlug(to);

	if (!user.value) {
		const redirectInfo = useCookieRedirect();
		redirectInfo.path.value = to.path;
		return navigateTo(merchantSlug.value
			? { name: 'MerchantLogin', params: { merchantSlug: merchantSlug.value } }
			: { name: 'GlobalLogin' });
	}
});
